export default __webpack_public_path__ + "static/media/optionsone.2d247db7.png";